import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Inbox } from 'lucide-react';

type Props = {
  icon?: LucideIcon;
  title: string;
  description?: string;
  children?: ReactNode;
};

export function EmptyState({ icon: Icon = Inbox, title, description, children }: Props) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-lg border border-dashed border-border bg-muted/20 px-6 py-12 text-center"
      role="status"
    >
      {/* Assinatura AgilizaOS: ícone em tile azure + linhas de velocidade da logo */}
      <div className="mb-3 flex items-center gap-2" aria-hidden>
        <span className="flex flex-col items-end gap-1">
          <span className="h-[3px] w-6 rounded-full bg-azure/60" />
          <span className="h-[3px] w-4 rounded-full bg-azure/35" />
          <span className="h-[3px] w-7 rounded-full bg-azure/20" />
        </span>
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border-2 border-azure/60 bg-card text-azure">
          <Icon className="h-6 w-6" />
        </span>
      </div>
      <p className="font-display text-base font-semibold text-foreground">{title}</p>
      {description ? (
        <p className="mt-2 max-w-md text-sm leading-relaxed text-muted-foreground">{description}</p>
      ) : null}
      {children ? <div className="mt-5 flex flex-wrap justify-center gap-2">{children}</div> : null}
    </div>
  );
}
